import { useCallback } from 'react'

import { useUpdateAssetMutation } from '~generated/hooks'
import { AssetTypes } from '~generated/types'

const useUpdateAssetType = (id: string, hasAssets: boolean) => {
  const [updateAsset, options] = useUpdateAssetMutation()
  const updateAssetsModuleInput = useCallback(
    (type: AssetTypes) => {
      if (type === AssetTypes.COPY && hasAssets) {
        // If user uploaded assets DON'T allow "copy" type
        return
      }

      updateAsset({
        variables: {
          input: {
            id,
            type,
          },
        },
      })
    },
    [hasAssets, id, updateAsset]
  )

  return [updateAssetsModuleInput, options] as const
}

export default useUpdateAssetType
